import { render, staticRenderFns } from "./AdminActions.vue?vue&type=template&id=0abfa0ea&lang=pug"
import script from "./AdminActions.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminActions.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AdminActions.vue?vue&type=style&index=0&id=0abfa0ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.18_cache-loader@4.1.0_webpack@4.47.0_supports-_a02809e54f1429825a019cd6b08a4fe2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports